import { useEffect } from "react";

export default function PortfolioField({
  register,
  fieldNamePrefix = "",
  setValue,
  watch,
}) {
  const minPortfolio = watch(`${fieldNamePrefix}_properties_in_portfolio_min`);
  const maxPortfolio = watch(`${fieldNamePrefix}_properties_in_portfolio_max`);

  useEffect(() => {
    if (setValue && minPortfolio !== undefined) {
      setValue("properties_in_portfolio_min", minPortfolio);
      setValue("owner_properties_in_portfolio_min", minPortfolio);
      setValue("recommend_properties_in_portfolio_min", minPortfolio);
    }
  }, [minPortfolio, setValue]);

  useEffect(() => {
    if (setValue && maxPortfolio !== undefined) {
      setValue("properties_in_portfolio_max", maxPortfolio);
      setValue("owner_properties_in_portfolio_max", maxPortfolio);
      setValue("recommend_properties_in_portfolio_max", maxPortfolio);
    }
  }, [maxPortfolio, setValue]);

  return (
    <div className="form_blk">
      <h6>Properties in portfolio</h6>
      <div className="half_flex">
        <div className="half_field">
          <input
            type="text"
            name={`${fieldNamePrefix}_properties_in_portfolio_min`}
            id={`${fieldNamePrefix}_properties_in_portfolio_min`}
            className="input"
            placeholder="Min"
            {...register(`${fieldNamePrefix}_properties_in_portfolio_min`)}
          />
        </div>
        <span></span>
        <div className="half_field">
          <input
            type="text"
            name={`${fieldNamePrefix}_properties_in_portfolio_max`}
            id={`${fieldNamePrefix}_properties_in_portfolio_max`}
            className="input"
            placeholder="Max"
            {...register(`${fieldNamePrefix}_properties_in_portfolio_max`)}
          />
        </div>
      </div>
    </div>
  );
}
